import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "io-mfe-ig-resources-pane flex min-height column full-height" }
const _hoisted_2 = { class: "io-mfe-ig-resource-tab-container min-height full-height full-width column" }

import ResearchPane from 'components/resources/ResearchPane.vue';
import AnalysisPane from 'components/resources/AnalysisPane.vue';
import EditsPane from 'components/resources/edits/EditsPane.vue';
import {storeToRefs} from 'pinia';
import {useLayoutStore} from 'stores/layout-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesPane',
  setup(__props) {

const { researchTab } = storeToRefs(useLayoutStore());

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_tabs, {
      modelValue: _unref(researchTab),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(researchTab) ? (researchTab).value = $event : null)),
      dense: "",
      "no-caps": "",
      outlined: "",
      class: "text-grey",
      "active-color": "primary",
      "indicator-color": "primary",
      align: "justify"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tab, {
          name: "research",
          icon: "fa-solid fa-book",
          label: "Research"
        }),
        _createVNode(_component_q_tab, {
          name: "analysis",
          icon: "fa-solid fa-binoculars",
          label: "MS DRG Analysis"
        }),
        _createVNode(_component_q_tab, {
          name: "edits",
          icon: "fa-regular fa-flag-pennant",
          label: "Edits"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_separator),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(ResearchPane, null, null, 512), [
        [_vShow, _unref(researchTab) == 'research']
      ]),
      _withDirectives(_createVNode(AnalysisPane, null, null, 512), [
        [_vShow, _unref(researchTab) == 'analysis']
      ]),
      _withDirectives(_createVNode(EditsPane, null, null, 512), [
        [_vShow, _unref(researchTab) == 'edits']
      ])
    ])
  ]))
}
}

})